const lang = {
  softbank_title: 'ソフトバンクユーザー様　専用ページ',
  btn_regist: '無料トライアルに申し込む',
  btn_submit: '入力内容を確認する',
  user_info: {
    email: 'メールアドレス',
    user_name: 'アカウント名',
    password: 'パスワード',
    confirm_password: 'パスワード（確認用）',
  },
  charge_info: {
    postal_code: '郵便番号（ハイフンなし）',
    street_address: '住所',
    building_name: '建物名',
    first_represent_label: '姓',
    last_represent_label: '名',
    first_represent: '代表者名（姓）',
    last_represent: '代表者名（名）',
    first_charge_label: '姓',
    last_charge_label: '名',
    first_charge: 'ご担当者名（姓）',
    last_charge: 'ご担当者名（名）',
    department_name: '部署名',
    phone_number: '電話番号（ハイフンなし）',
  },
  company_name: 'ソフトバンク株式会社'
}
  
export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/softbank.js